import React from 'react'
import { Layout } from '@arco-design/web-react'
import { FooterProps } from '@arco-design/web-react/es/Layout/interface'
import cs from 'classnames'
import styles from './style/index.module.less'
import useLocale from '@/hooks/useLocale'
function Footer(props: FooterProps = {}) {
  const { className, ...restProps } = props
  const t = useLocale()
  return (
    <Layout.Footer className={cs(styles.footer, className)} {...restProps}>
      <span style={{ marginRight: "5px" }}>{t["login.msg.technicalSupport"]}</span>
      <a href="http://www.loong-in.com/" target="_blank" rel="noreferrer">
        http://www.loong-in.com/
      </a>
    </Layout.Footer>
  )
}

export default Footer

